import {
  Button,
  Container,
  FormControl,
  FormHelperText,
  FormLabel,
  Input,
} from "@mui/joy";
import { Stack } from "@mui/material";
import * as React from "react";
import { useLocation, useNavigate } from "react-router";
import HeaderBackButton from "../components/HeaderBackButton";
import { CurrencyFormat } from "../config/services";

export default function Send() {
  const navigate = useNavigate();
  let { state } = useLocation();
  const { code, balance, price } = state;
  const [data, setData] = React.useState({
    amount: 0,
    coin: 0,
    address: "",
    network: "Bitcoin",
  });

  const px = Number(price) || 0;
  const toUsd = (coinAmount) => Number(coinAmount) * px;
  const toCoin = (usdAmount) => (px > 0 ? Number(usdAmount) / px : 0);

  const handleChange = (event) => {
    setData((prev) => ({
      ...prev,
      [event.target.name]: event.target.value,
    }));
  };

  const pasteAddress = async () => {
    try {
      const text = await navigator.clipboard.readText();
      setData((prev) => ({ ...prev, address: text }));
    } catch (error) {
      console.error("Failed to read clipboard contents: ", error);
    }
  };

  const setMaxAmount = () => {
    if (balance > 0) {
      setData((prev) => ({
        ...prev,
        coin: toCoin(balance),
        amount: Number(balance),
      }));
    }
  };

  const amountNum = Number(data.amount) || 0;
  const canContinue =
    amountNum > 0 &&
    Number(balance) > 0 &&
    amountNum <= Number(balance) &&
    Boolean(data.address?.trim());

  return (
    <>
      <HeaderBackButton title={`Send ${code}`} />

      <Container maxWidth="sm">
        <Stack spacing={6} mt={4}>
          <FormControl>
            <FormLabel>Receiver {code} address</FormLabel>
            <Input
              size="lg"
              sx={{ "--Input-decoratorChildHeight": "45px" }}
              name="address"
              placeholder="Address"
              type="text"
              required
              value={data.address}
              onChange={handleChange}
              endDecorator={
                <Button
                  variant="soft"
                  color="neutral"
                  type="button"
                  sx={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
                  onClick={pasteAddress}
                >
                  Paste
                </Button>
              }
            />
          </FormControl>

          <FormControl>
            <FormLabel>{code} amount</FormLabel>
            <Input
              name="coin"
              size="lg"
              sx={{ "--Input-decoratorChildHeight": "45px" }}
              placeholder="0.00"
              type="number"
              required
              value={data.coin}
              onChange={(event) => {
                const coin = event.target.value;
                setData((prev) => ({
                  ...prev,
                  coin,
                  amount: coin > 0 ? toUsd(coin) : 0,
                }));
              }}
              endDecorator={
                <Button
                  variant="solid"
                  color="primary"
                  type="button"
                  sx={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
                  onClick={setMaxAmount}
                >
                  Max
                </Button>
              }
            />
            <FormHelperText>
              Receiver gets{" "}
              <CurrencyFormat
                amount={data.amount}
                prefix={"$"}
                seperator={true}
              />
            </FormHelperText>
          </FormControl>

          <Button
            variant="solid"
            color="primary"
            fullWidth
            size="lg"
            disabled={!canContinue}
            onClick={() =>
              navigate("/passcode", {
                state: {
                  coin: state,
                  data: data,
                },
              })
            }
          >
            Continue
          </Button>
        </Stack>
      </Container>
    </>
  );
}
